import { motion } from "framer-motion";

export default function Act3Twist() {
  return (
    <section data-testid="act-twist" className="relative h-[80vh] md:h-screen w-full overflow-hidden bg-[#030303] flex items-center justify-center">
      {/* Subtle gold glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.08),transparent_55%)]" />

      <div className="relative z-10 max-w-4xl mx-auto text-center px-6 md:px-12">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="block font-display text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-10"
        >
          La verdad incómoda
        </motion.span>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-white leading-[1.05] tracking-tight text-4xl sm:text-6xl md:text-7xl text-balance"
        >
          El problema nunca fue tu cuerpo.
        </motion.p>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
          className="mt-4 font-serif italic gold-text leading-[1.05] tracking-tight text-4xl sm:text-6xl md:text-7xl"
        >
          Fue dejar de confiar en quien lo habita.
        </motion.p>
      </div>
    </section>
  );
}
